import type { LocalStorageState } from './types';

class LocalStorageService<T> {
    setItem<M extends keyof T>(key: M, value: T[M]): void {
        return localStorage.setItem(key as string, JSON.stringify({ value }));
    }

    removeItem<M extends keyof T>(key: M): void {
        localStorage.removeItem(key as string);
    }

    getItem<M extends keyof T>(key: M): T[M] | null;
    getItem<M extends keyof T>(key: M, defaultValue: T[M]): T[M];
    getItem<M extends keyof T>(key: M, defaultValue?: T[M]): T[M] | null {
        if (!localStorage) {
            return null;
        }
        const data: string | null = localStorage.getItem(key as string);

        if (data !== null) {
            return JSON.parse(data).value as T[M];
        }

        if (defaultValue) {
            return defaultValue;
        }

        return null;
    }
}

export const localStorageService = new LocalStorageService<LocalStorageState>();
